import { Injectable } from '@angular/core';
import { buttonsFirst, buttons, buttonsLast } from '../botones';

@Injectable({ providedIn: 'root' })
export class StepsEnviosConsultar {
  constructor() {
    this.crear();
  }

  crear() {
    return [
      {
        attachTo: {
          element: '.step_100',
          on: 'bottom' as const,
        },
        title: 'CONSULTAR ENVÍOS',
        text: `
                    En esta página puede consultar los envíos que ha realizado y ver sus cambios en tiempo real.
                `,
        buttons: buttonsFirst,
      },
      {
        attachTo: {
          element: '.step_200',
          on: 'bottom' as const,
        },
        title: 'NUEVO ENVÍO',
        text: `
                    Si quiere crear un nuevo envío puede utilizar este botón.  Recuerde que también puede hacerlo desde la página de PLANTILLAS o desde NUEVO ENVÍO, en el menú superior.
                `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_300',
          on: 'bottom' as const,
        },
        title: 'COLUMNAS Y ACCIONES',
        text: `
                    Puede seleccionar las <b>columnas</b> que se mostrarán en el listado según sus prioridades.<br><br>
                    Desde el menú <b>⋮</b> puede <b>exportar</b> en CSV y <b>limpiar los filtros</b> activos.
                `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_600',
          on: 'bottom' as const,
        },
        title: 'COLUMNAS',
        text: `
                    Al pulsar sobre cada columna se ordenarán los registros de forma ascendente o descendente.  También puede reordenar las columnas arrastrándolas a la posición deseada manteniendo pulsado el botón del ratón.
                `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_700',
          on: 'bottom' as const,
        },
        title: 'FILTROS',
        text: `
                    Puede filtrar los registros por columnas introduciendo valores en estas casillas.
                `,
        buttons: buttons,
      },

      {
        attachTo: {
          element: '.p-datatable-tbody',
          on: 'bottom' as const,
        },
        title: 'DATOS',
        text: `
                    En la parte central de la tabla tendrá acceso a los registros.  En la última columna se muestran las acciones que puede realizar sobre cada registro.
                `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.p-paginator',
          on: 'bottom' as const,
        },
        title: 'PAGINADOR',
        text: `
                    Puede cambiar de página utilizando el paginador y el número de registros mostrados en cada página.
                `,
        buttons: buttonsLast,
      },
    ];
  }
}
